import React from 'react';
import { useOutlet } from 'react-router-dom'

import Footer from 'components/Footer/Footer'
import Navbar from 'components/Navbar/Navbar'
import usePageLayoutLogic from './hooks/usePageLayoutLogic'
import PageLoader from 'components/PageLoader/PageLoader'
import useTextContents from 'common/hooks/useTextContents'

import './PageLayout.scss'

const PageLayout = () => {
   const { showFooter, showNavbar } = usePageLayoutLogic()
   const loadersTextContent = useTextContents()
   const outlet = useOutlet()

   return (
      <div className='page-wrapper'>
         <Navbar showNavbar={showNavbar} />
         <main className='page-layout-outer-wrapper'>
            <div className='page-content-wrapper'>
              {outlet || <PageLoader waitingText={loadersTextContent('loaders.default')} /> }
            </div>
         </main>
         <Footer showFooter={showFooter} />
      </div>
   )
}

export default PageLayout